(() => {
  if (window.BanagoyaCloudinaryUploadLoaded) return;
  window.BanagoyaCloudinaryUploadLoaded = true;

  const CLOUD_NAME = 'm5ishneo';
  const UPLOAD_PRESET = 'shopify_customer_uploads';
  const MAX_FILE_SIZE = 20 * 1024 * 1024; // 20 MB
  const UPLOAD_URL = `https://api.cloudinary.com/v1_1/${CLOUD_NAME}/image/upload`;

  const buttonStates = new WeakMap();

  function getStatusElement(fileInput) {
    let status = fileInput.parentElement.querySelector(
      '.cloudinary-upload-status'
    );

    if (!status) {
      status = document.createElement('div');
      status.className = 'cloudinary-upload-status';
      status.setAttribute('aria-live', 'polite');
      status.style.marginTop = '8px';
      status.style.fontSize = '0.875rem';
      fileInput.insertAdjacentElement('afterend', status);
    }

    return status;
  }

  function getHiddenUrlInput(fileInput) {
    let hiddenInput = fileInput.parentElement.querySelector(
      'input[data-cloudinary-url]'
    );

    if (!hiddenInput) {
      const propertyName = fileInput.getAttribute('name');

      if (!propertyName) {
        throw new Error('The upload field has no Shopify property name.');
      }

      hiddenInput = document.createElement('input');
      hiddenInput.type = 'hidden';
      hiddenInput.name = propertyName;
      hiddenInput.setAttribute('data-cloudinary-url', '');
      hiddenInput.setAttribute('form', fileInput.getAttribute('form') || '');

      fileInput.removeAttribute('name');
      fileInput.insertAdjacentElement('afterend', hiddenInput);
    }

    return hiddenInput;
  }

  function getForm(fileInput) {
    return fileInput.form || document.getElementById(
      fileInput.getAttribute('form')
    );
  }

  function getFormButtons(form) {
    if (!form) return [];

    return Array.from(
      form.querySelectorAll(
        'button[type="submit"], input[type="submit"]'
      )
    );
  }

  function setFormUploading(form, isUploading) {
    if (!form) return;

    const currentCount = Number(form.dataset.cloudinaryUploads || 0);
    const nextCount = isUploading
      ? currentCount + 1
      : Math.max(0, currentCount - 1);

    form.dataset.cloudinaryUploads = String(nextCount);

    getFormButtons(form).forEach((button) => {
      if (nextCount > 0) {
        if (!buttonStates.has(button)) {
          buttonStates.set(button, button.disabled);
        }

        button.disabled = true;
        button.setAttribute('aria-disabled', 'true');
      } else {
        const wasDisabled = buttonStates.get(button);

        if (wasDisabled === false) {
          button.disabled = false;
          button.removeAttribute('aria-disabled');
        }

        buttonStates.delete(button);
      }
    });
  }

  function setStatus(status, message, state) {
    status.textContent = message;
    status.dataset.state = state;

    if (state === 'success') {
      status.style.color = 'green';
    } else if (state === 'error') {
      status.style.color = 'red';
    } else {
      status.style.color = 'inherit';
    }
  }

  async function uploadImage(fileInput) {
    const file = fileInput.files?.[0];
    const status = getStatusElement(fileInput);
    const hiddenInput = getHiddenUrlInput(fileInput);
    const form = getForm(fileInput);

    hiddenInput.value = '';
    fileInput.dataset.cloudinaryState = '';

    if (!file) {
      setStatus(status, '', '');
      return;
    }

    if (!file.type.startsWith('image/') && file.type !== 'application/pdf') {
      fileInput.value = '';
      fileInput.dataset.cloudinaryState = 'error';
      setStatus(status, 'Please select an image or PDF file.', 'error');
      return;
    }

    if (file.size > MAX_FILE_SIZE) {
      fileInput.value = '';
      fileInput.dataset.cloudinaryState = 'error';
      setStatus(status, 'The image must be smaller than 20 MB.', 'error');
      return;
    }

    fileInput.dataset.cloudinaryState = 'uploading';
    setStatus(status, 'Uploading image…', 'uploading');
    setFormUploading(form, true);

    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('upload_preset', UPLOAD_PRESET);
      formData.append('folder', 'Customer Uploads/Order Uploads');

      const response = await fetch(UPLOAD_URL, {
        method: 'POST',
        body: formData
      });

      const result = await response.json();

      if (!response.ok || !result.secure_url) {
        throw new Error(
          result?.error?.message || 'Cloudinary did not return an image URL.'
        );
      }

      hiddenInput.value = result.secure_url;
      fileInput.dataset.cloudinaryState = 'success';

      setStatus(status, 'Image uploaded successfully.', 'success');
    } catch (error) {
      console.error('Cloudinary upload failed:', error);

      hiddenInput.value = '';
      fileInput.dataset.cloudinaryState = 'error';

      setStatus(
        status,
        'Image upload failed. Please select the file again.',
        'error'
      );
    } finally {
      setFormUploading(form, false);
    }
  }

  document.addEventListener('change', (event) => {
    const fileInput = event.target.closest(
      'product-custom-property-component input[type="file"]'
    );

    if (!fileInput) return;

    uploadImage(fileInput);
  });

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target;

      if (!(form instanceof HTMLFormElement)) return;

      const relatedFileInputs = Array.from(
        document.querySelectorAll(
          'product-custom-property-component input[type="file"]'
        )
      ).filter((input) => input.form === form);

      const unfinishedInput = relatedFileInputs.find((input) => {
        if (!input.files?.length) return false;

        return input.dataset.cloudinaryState !== 'success';
      });

      if (!unfinishedInput) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      const status = getStatusElement(unfinishedInput);

      setStatus(
        status,
        unfinishedInput.dataset.cloudinaryState === 'uploading'
          ? 'Please wait until the image finishes uploading.'
          : 'Please upload the image again before adding the item to cart.',
        'error'
      );

      unfinishedInput.scrollIntoView({
        behavior: 'smooth',
        block: 'center'
      });
    },
    true
  );
})();